/**
 * Created by jpilz on 2/13/17.
 */
import ko from 'knockout';
import $ from 'jquery';

export default class customUtil {

    constructor(context) {
        this.name = "customUtil";
        this.context = context;
        console.log("customUtil");

    }

    returnEmptyObj(columnid) {
        return {subparentid: this.context.subparentid(), partnerid: this.context.partnerid(), columnid: columnid, label: "", value: 1, sort: 1, valid: 1};
    }

    returnDataByCoulmnid(columnid) {

        switch(columnid) {

            case 1:
            return this.context.customHeaderColumn1Data;
            break;

            case 2:
            return this.context.customHeaderColumn2Data;
            break;

            case 3:
            return this.context.customHeaderColumn3Data;
            break;

            case 4:
            return this.context.customHeaderColumn4Data;
            break;

            case 5:
            return this.context.customHeaderColumn5Data;
            break;

            case 6:
            return this.context.customHeaderColumn6Data;
            break;

            default:
            return null;
            break;
        }

    }

    getCustomHeaderTitles() {

        //{"where": {"subid":"900423599"}}
         console.log("customUtil:getOptionHeaders");
 
         let filter = encodeURI(JSON.stringify({ "where" : { "subpartnerid" : this.context.subparentid(), "partnerid": this.context.partnerid() } } ));
         let url = this.context.generateApiUrl('/Optiontitles/GetTitles');
         let callData = JSON.stringify({ subid:this.context.subparentid(), partnerid:this.context.partnerid() });
 
         return new Promise((resolve, reject) => {
             $.ajax({
                 url: url,
                 method: 'POST',
                 headers: this.context.apiContentType,
                 data: callData
             }).done((response, textResponse, request) => {
                console.log("customUtil:getCustomHeaderTitles data: %o", response.data[0]);
                this.context.customHeaderTitles(response.data[0]);
                this.context.customHeaderTitles.valueHasMutated();
                console.log("customUtil:getCustomHeaderTitles context.customHeaderTitles: %o", this.context.customHeaderTitles());
                resolve(true);
             }).fail((error) =>{
                 console.log("customUtil:getOptionHeaders Error: %o", error);
                 reject(false);
                 this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting customUtil:getOptionHeaders"},"messageModel");
                 return;
             });
         });

    }

    updateCustomHeaderTitles() {

        console.log("customUtil:updateCustomHeaderTitles");
 
        //let filter = encodeURI(JSON.stringify({ "where" : { "subid" : this.context.subid()} } ));
        let url = this.context.generateApiUrl('/Optiontitles/replaceOrCreate');
        let callData = ko.toJSON(this.context.customHeaderTitles);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
               console.log(data);
               resolve(true);
            }).fail((error) =>{
                console.log("customUtil:updateCustomHeaderTitles Error:");
                reject(false);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting updateCustomHeaderTitles"},"messageModel");
                return;
            });
        });

    }

    getAllCustomHeaderData() {

        console.log("customUtil:getAllCustomHeaderData:");
        this.getCustomHeaderData(1).then();
        this.getCustomHeaderData(2).then();
        this.getCustomHeaderData(3).then();
        this.getCustomHeaderData(4).then();
        this.getCustomHeaderData(5).then();
        this.getCustomHeaderData(6).then();
    }

    getCustomHeaderData(columnID) {

         console.log("customUtil:getCustomHeaderData");

         // { "where" : { "subid" : "900423599", "columnid":"1"}, "order": "label ASC"}
 
         let filter = encodeURI(JSON.stringify({ "where" : { "subparentid" : this.context.subparentid(),"partnerid":this.context.partnerid(),"columnid":columnID, "valid":1 }, "order": "label ASC"}));
         let url = this.context.generateApiUrl('/Options' + '?filter=' + filter);
         let callData = JSON.stringify({});
 
         return new Promise((resolve, reject) => {
             $.ajax({
                 url: url,
                 method: 'get',
                 headers: this.context.apiContentType,
                 data: callData
             }).done((data, textResponse, request) => {
                console.log(data[0]);
                this.handleCustomHeaderData(data,columnID);
                resolve(true);
             }).fail((error) =>{
                 console.log("customUtil:getCustomHeaderData Error:");
                 reject(false);
                 this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting getCustomHeaderData"},"messageModel");
                 return;
             });
         });

    }

    updateCustomHeaderData(customObj) {

        console.log("customUtil:updateCustomHeaderData");

        // { "where" : { "subid" : "900423599", "columnid":"1"}, "order": "label ASC"}

        let url = this.context.generateApiUrl('/Options/replaceOrCreate');
        let callData = ko.toJSON(customObj);

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
               resolve(true);
            }).fail((error) =>{
                console.log("customUtil:updateCustomHeaderData Error:");
                reject(false);
                this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting updateCustomHeaderData"},"messageModel");
                return;
            });
        });

   }

    handleCustomHeaderData(data,columnID) {

        switch(columnID) {

            case 1:
            this.context.customHeaderColumn1Data(data);
            break;

            case 2:
            this.context.customHeaderColumn2Data(data);
            break;

            case 3:
            this.context.customHeaderColumn3Data(data);
            break;

            case 4:
            this.context.customHeaderColumn4Data(data);
            break;

            case 5:
            this.context.customHeaderColumn5Data(data);
            break;

            case 6:
            this.context.customHeaderColumn6Data(data);
            break;
        }

        return;

    }

    report(columnid) {

        console.log("customUtil:report: cloumnid: ", columnid);
 
        //let filter = encodeURI(JSON.stringify({ "where" : { "subid" : this.context.subid()} } ));
        let url = this.context.generateApiUrl('/Options/Report');
        let callData = JSON.stringify({subid: this.context.subparentid(), partnerid: this.context.partnerid(), columnid: columnid});

        return new Promise((resolve, reject) => {
            $.ajax({
                url: url,
                method: 'POST',
                headers: this.context.apiContentType,
                data: callData
            }).done((data, textResponse, request) => {
               console.log("customUtil:report data: %o", data);
               resolve(data.data);
            }).fail((error) =>{
                console.log("customUtil:report Error: %o", error);
                console.log("customUtil:report Error - subid: %s, partnerid: %i, columnid: %i", this.context.subid(), this.context.partnerid(),columnid);
                reject(false);
                //this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error getting customUtil:report"},"messageModel");
                return;
            });
        });

    }




}




// WEBPACK FOOTER //
// ./src/objects/customUtil.js